module.exports = __webpack_public_path__ + "49f68d5c54affb8ff0965ffa139d7461.png";